import React from "react";
import './body.css';
import Container from "./Container";


export default function Body(){

    return(
        <div className="Body">
            <Container id="about" text='About' />
            <Container id="highlights" text='Highlights' />
            <Container id="tech_summary" text='Technical Summary' />
            <Container id="experience" text='Professional Experience' />
            <Container id="education" text='Education' />
            <Container id="contact" text='Contact' />
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/Body.js